// This code listens for clicks on elements with the ".sff-buy-now" class,
// collects data from the associated product form, and sends it to Shopify’s cart via AJAX.
// After successfully adding the product, it immediately redirects the user to checkout,
// bypassing the cart page. During the process, it temporarily disables the button
// and shows a "HOLD ON..." state, and restores it if an error occurs.

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.sff-buy-now');
  if (!btn) return;

  const productForm =
    btn.closest('product-form')?.querySelector('form[action*="/cart/add"]') ||
    btn.closest('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  if (!productForm) {
    console.error('SFF BUY NOW: product form not found.');
    return;
  }

  try {
    // UX lock
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.innerText = 'HOLD ON...';

    const formData = new FormData(productForm);

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('SFF BUY NOW error:', errorText);

      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.innerText = 'CHECKOUT';
      return;
    }

    // direktno na checkout
    window.location.href = window.Shopify.routes.root + 'checkout';

  } catch (error) {
    console.error('SFF BUY NOW crash:', error);

    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.innerText = 'CHECKOUT';
  }
});


